export function getMessageUsername(message) {
  const {first_name: firstName, last_name: lastName, username} = message.user;
  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  }

  return username;
}
